import React from "react";
import { StoryblokAsset } from "../interfaces/Storyblok/StoryblokAsset.interface";

interface BuildingType {
  name: string;
  description: string;
  icon: string;
  cardIcon: string;
  websiteFilterItem: string;
  row_idx: number;
}

interface Facility {
  name: string;
  icon: string;
  cardIcon: string;
  websiteFilterItem: string;
  location: string;
  row_idx: number;
}

export interface EventCategory {
  name: string;
  icon: string;
}

export interface ExperienceType {
  name: string;
  icon: string;
}

export interface Club {
  name: string;
  description: string;
  icon: string;
  clubType: string;
  cardIcon: string;
  websiteFilterItem: string;
  row_idx: number;
}

interface InspectionStandard {
  referenceNumber: string;
  type: string;
  rating: string;
  applicationDate: string;
  registrationDate: string;
  resignedDate: string;
  reportLink: string;
}

export interface Event {
  activity: string;
  description: string;
  date: string;
  image: string;
  additionalCost: string;
  type: string;
  discountedCost: string;
  eventName: string;
  group: string;
  startTime: string;
  endTime: string;
  eventCategories: EventCategory[];
  experienceType: ExperienceType;
  viewTimetable?: string;
}

export interface Service {
  reference: string;
  name: string;
  daysRunning: number;
  term: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  currentPrice: number;
  tieredPricing: boolean;
  prices: any[];
  discountedPrice: number;
  bookingStartDate: string;
  bookingEndDate: string;
  earlyFinish: string;
  lateFee: number;
  cancellationPeriod: string;
  registrationFee: string;
  events: Event[];
  clubType: string;
  bookingCutOff: string;
}

export interface VenueWithinRange extends Venue {
  distanceBetween: number;
}
export interface Venue {
  id: string;
  name: string;
  // The venue's Kidsoft service UUID (Airtable "Kidsoft ID"), used as HubSpot's
  // `service_id`. Present on the AU brand bases; undefined where the column is absent.
  kidsoftId?: string;
  status: string;
  // null whenever the Airtable record has no Building Type linked (see transformVenueData).
  buildingType: BuildingType | null;
  age: {
    min: number;
    max: number;
  };
  nearbyVenues: string[];
  contactNumber: string;
  showVenuePhoneNumber: boolean;
  contactEmail: string;
  address: {
    line1: string;
    line2: string;
    townCity: string;
    county: string;
    postcode: string;
    localAuthority: string;
    region: string;
  };
  coords: {
    lat: number;
    lng: number;
  };
  facilities: Facility[];
  links: {
    website_url: string;
    venueWebsite: string;
    bookingLink: string;
    availabiltyLink: string;
    registrationLink: string;
  };
  permanentBookingCancellation: string;
  pickupLateFee: number;
  pickupAndDropoffInstructions: string;
  noShowFee: number;
  dailyDiscount: string;
  weeklyDiscount: string;
  siblingDiscount: string;
  serviceListInfoTitle: string;
  serviceListInfoCopy: string;
  inspectionStandards: InspectionStandard | undefined;
  clubs: Club[];
  services: Service[];
  termsLink: string;
  holidayScheduleLink: string;
}

const VenuesContext = React.createContext<Venue[]>([]);

export default VenuesContext;
